import { Button, ButtonProps, SxProps } from '@mui/material';
import { styled } from '@mui/system';
import { icons } from '../../assets/icons/icons';
import { calculateBackgroundMode, calculateIconMode, colors_button, modeType } from './util.button';

const icons_button = {
    ...icons
};

interface CustomButtonProps extends ButtonProps {
    bg?: string;
    text?: string;
    border?: string;
    width?: string;
    padding?: string;
    margin?: string;
}

const BaseButton = styled(Button)<{ customProps: CustomButtonProps }>(
    ({ theme, customProps }) => ({
        backgroundColor: customProps.bg,
        color: customProps.text || colors_button.white,
        transition: 'all .4s ease',
        borderRadius: '8px',
        textTransform: "none",
        border: `1.7px solid ${customProps.border || 'transparent'}`,
        width: customProps.width || 'auto',
        padding: customProps.padding || 'default padding',
        margin: customProps.margin || 'default margin',
        '&:hover': {
            border: `1.8px solid ${customProps.border || 'transparent'}`,
            backgroundColor: customProps.bg,
            color: customProps.text || colors_button.white,
            opacity: 0.5,
        },
        '&:focus': {
            border: `1.8px solid ${customProps.border || 'transparent'}`,
        },
        '&:disabled': {
            border: `1.8px solid #fefefe`,
            boxShadow: '2px 1px 1px 0px rgba(0,0,0,0.12)'
        },
        [theme.breakpoints.down('md')]: {

        },
    })
);

type PropsType = {
    buttonName?: string;
    btnProps?: CustomButtonProps;
    mode?: string;
    ButtonProps?: ButtonProps
    onClick?: () => void;
    disabled?: boolean;
    iconComponent?: React.ReactNode;
    type?: any;
    fullWidth?: boolean;
    onKeyPress?: (event: React.KeyboardEvent) => void;
    sx?: SxProps;
    className?: string;
    startIconComponent?:any
};

type PropsBtnIcon = {
    icon: string;
    color?: string;
    size?: string;
    border?: string;
    bg?: string;
};

const ButtonPrimary = ({ mode, buttonName,startIconComponent, btnProps, ...rest }: PropsType) => {
    const icon = calculateIconMode(mode);
    const bg = calculateBackgroundMode(mode);

    return (
        <BaseButton
            {...rest}
            // disabled={props.disabled}
            // onClick={props.onClick}
            // customProps={{ ...btnProps, bg, text: colors_button.white, border: bg }}
            customProps={{
                ...btnProps,
                bg: btnProps?.bg || bg,
                text: btnProps?.text ? btnProps?.text : colors_button.white,
                border: btnProps?.bg || bg,
            }}
            variant='contained'
            startIcon={startIconComponent ? startIconComponent  : icon ? <img src={icon} alt="Icon"
                style={{
                    filter: mode === "send_request" ? "brightness(0) invert(1)" : ""
                }}
            /> : undefined}
        >
            {buttonName}
        </BaseButton>
    );
}

const ButtonOutlined = (props: PropsType) => {
    const { btnProps, mode } = props;

    const icon = calculateIconMode(mode);
    const bg = calculateBackgroundMode(mode);
    return (
        <BaseButton
            onClick={props.onClick}
            customProps={{ ...props.btnProps, bg: props.btnProps?.bg || colors_button.white, text: colors_button.text, border: btnProps?.border || colors_button.text }}
            variant='outlined'
            startIcon={props.startIconComponent ? props.startIconComponent  :  icon ? <img src={icon} alt="Icon"
                style={{
                    filter: mode === "send_request" ? "brightness(0) invert(1)" : ""
                }}
            /> : undefined}
        >
            {props.buttonName}
        </BaseButton>
    );
}

export const ButtonContained = ({ mode, sx, buttonName, onClick, btnProps, iconComponent, fullWidth, type, onKeyPress, className, ...rest }: PropsType) => {

    const Icon = calculateIconMode(mode)
    const bg = calculateBackgroundMode(mode)

    return (
        <BaseButton
            {...rest}
            sx={sx}
            type={type}
            fullWidth={fullWidth}
            onKeyPress={onKeyPress}
            customProps={{ ...btnProps, bg: btnProps?.bg || bg, text: colors_button.white, width: fullWidth ? "100%" : btnProps?.width || undefined, border: btnProps?.bg || bg }}
            variant='contained'
            startIcon={iconComponent ? iconComponent : Icon ? <Icon /> : undefined}
            onClick={onClick}
            className={className}
        >
            {buttonName || 'ตกลง'}
        </BaseButton>
    );
}

const ButtonDraft = (props: PropsType) => (
    <BaseButton
        onClick={props.onClick}
        customProps={{ ...props.btnProps, bg: props.btnProps?.bg || colors_button.sky, text: colors_button.white, border: colors_button.sky }}
        variant='contained'
        startIcon={<img src={icons_button.draft} alt='icons' />}
    >
        {props.buttonName}
    </BaseButton>
)

const ButtonBack = (props: PropsType) => (
    <BaseButton
        onClick={props.onClick}
        customProps={{ ...props.btnProps, bg: props.btnProps?.bg || colors_button.white, text: colors_button.text, border: colors_button.text }}
        variant='outlined'
    >
        {props.buttonName}
    </BaseButton>
)

const ButtonDel = (props: PropsType) => {
    return (
        <BaseButton
            onClick={props.onClick}
            customProps={{ ...props.btnProps, bg: props.btnProps?.bg || colors_button.red, text: colors_button.white, border: colors_button.red }}
        >
            {props.buttonName}
        </BaseButton>
    )
}


export { ButtonDel, ButtonBack, ButtonDraft, ButtonPrimary, ButtonOutlined };
